import PosthogService from '~/services/posthog/PosthogService';

export interface IV0RequestSubmittedPayload {
  shiftsPosted: number;
  totalInvitesSent: number;
}

/**
 * Fires when the user clicks the active "Send Request" button on the
 * "Review & Confirm" step of the OLD Shift Request flow
 * Event: dental_portal:shift_request:request_submitted
 */
export function fireV0RequestSubmitted(payload: IV0RequestSubmittedPayload): void {
  PosthogService.getInstance().track('dental_portal:shift_request:request_submitted', {
    shifts_posted: payload.shiftsPosted,
    'Design Date': 202401,
    total_invites_sent: payload.totalInvitesSent,
  });
}
